// extracted by mini-css-extract-plugin
export default {"title":"postpreviewhome-module--title--AO7zW","post_info":"postpreviewhome-module--post_info--DHy5c"};